import { PiPlusBold } from "react-icons/pi";
import { Button } from "../ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../ui/alert-dialog";
import { useEffect, useState } from "react";
import { DatePicker } from "../ui/datepicker";
import apiDiarioOperacao from "../../services/apis/apiDiarioOperacao";
import { useToast } from "../../contexts/ToastContext";
import { format } from "date-fns";

export default function AdicionarOuEditarRegistro({
    openModal,
    setOpenModal,
    openModalAdd,
    modalState,
    registroEdit,
    updateList
}) {

    const { sucesso, erro } = useToast();

    const [form, setForm] = useState({
        nomeCompleto: '',
        data: new Date(),
        descricao: ''
    });


    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            if (modalState === "Adicionar") {
                await apiDiarioOperacao.create(form);
                sucesso('Registro criado com sucesso!');
            } else {
                await apiDiarioOperacao.update(form, registroEdit.id);
                sucesso('Registro editado com sucesso!');
            }
            setForm({
                nomeCompleto: '',
                data: format(new Date(), 'yyyy-MM-dd'),
                descricao: ''
            });
            await updateList(1);

        } catch (error) {
            erro('Erro ao criar ou editar o registro. Tente novamente.');
        }
    }

    useEffect(() => {
        if (modalState === "Editar" && registroEdit) {
            setForm({
                nomeCompleto: registroEdit.nomeCompleto,
                data: format(new Date(registroEdit.data + "T00:00:00"), 'yyyy-MM-dd'),
                descricao: registroEdit.descricao
            });

        } else {
            setForm({
                nomeCompleto: '',
                data: format(new Date(), 'yyyy-MM-dd'),
                descricao: ''
            });
        }
    }, [modalState, registroEdit]);

 return (
    <div className="w-full flex justify-end">
        <AlertDialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
            <Button onClick={() => openModalAdd()} title="Adicionar Registro">
                <PiPlusBold size={18} />
            </Button>
            <AlertDialogContent className="w-[95vw] max-w-[1000px] sm:w-[90vw] md:w-[80vw]">
                <form onSubmit={handleSubmit}>
                    <AlertDialogHeader>
                        <AlertDialogTitle>{modalState} Registro</AlertDialogTitle>
                        <div className="flex flex-col gap-5 w-full">
                            <div className="flex flex-col md:flex-row w-full gap-5 md:gap-0 md:justify-between">
                                <div className="flex flex-col">
                                    <label
                                        htmlFor="nome"
                                        className="text-[18px] mb-2"
                                    >
                                        Nome Completo
                                    </label>
                                    <input
                                        id="nome"
                                        className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-full md:w-[400px]"
                                        type="text"
                                        placeholder="nome completo"
                                        value={form.nomeCompleto}
                                        onChange={(e) =>
                                            setForm({ ...form, nomeCompleto: e.target.value })
                                        }
                                        required
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label
                                        htmlFor="data"
                                        className="text-[18px] mb-2"
                                    >
                                        Data
                                    </label>
                                    <DatePicker
                                        className="!border-b text-[20px] p-1.5 bg-[#0b101d] !rounded-t-md w-full md:!w-[400px] h-11"
                                        onDateChange={(date) => {
                                            if(!date) return;
                                            setForm({
                                                ...form, data: format(new Date(date), 'yyyy-MM-dd')
                                            })
                                        }}
                                        required
                                        initialDate={registroEdit?.data ? new Date(registroEdit.data + "T00:00:00").toString() : new Date()}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col w-full">
                                <label
                                    htmlFor="descricao"
                                    className="text-[18px] mb-2"
                                >
                                    Descrição
                                </label>
                                <textarea
                                    id="descricao"
                                    className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-full min-h-[160px] max-h-[400px]"
                                    placeholder="descrição do registro"
                                    value={form.descricao}
                                    onChange={(e) =>
                                        setForm({ ...form, descricao: e.target.value })
                                    }
                                    required
                                />
                            </div>
                        </div>
                    </AlertDialogHeader>
                    <AlertDialogFooter className="mt-5 flex-col sm:flex-row gap-2 sm:gap-0">
                        <AlertDialogCancel>Cancelar</AlertDialogCancel>
                        <AlertDialogAction>
                            Salvar
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </form>
            </AlertDialogContent>
        </AlertDialog>
    </div>
)
}